module.exports = __webpack_public_path__ + "img/img-46.00ea65b2.png";